import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Blog from "../../Component/Blog/Blog";
import FilterControl from "../../Component/FilterControl/FilterControl";
import Loading from "../../Component/Loading/Loading";
import { fetchBlogs } from "../../features/Blogs/BlogsSlice";

const Blogs = () => {
  
  const dispatch = useDispatch();
  const {filter, sort} = useSelector(state => state.filtered)

  useEffect(() => {
    dispatch(fetchBlogs({filter, sort}));
  }, [dispatch, filter, sort]);

  const { blogs, isLoading, isError, error } = useSelector(
    (state) => state.blogs
  );

  let content;

  if (isLoading) content = <Loading></Loading>;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && blogs?.length === 0)
    content = <div className="col-span-12">sorry! No video found.</div>;

  if (!isError && !isLoading && blogs?.length > 0)
    content = blogs.map((blog) => <Blog key={blog.id} blog={blog}></Blog>);

  return (
    <>
      <section className="wrapper">
        <aside>
          <FilterControl></FilterControl>
        </aside>

        {/* <!-- posts container  --> */}
        <main className="post-container" id="lws-postContainer">
          {content}
        </main>
      </section>
    </>
  );
};

export default Blogs;
